<ion-header>
  <ion-toolbar>
    <ion-buttons slot="end">
      <div class="logo"><a (click)="close()"><img alt="RichDate" src="assets/img/icons/logo.png"></a></div>
    </ion-buttons>
    <ion-buttons slot="start">
      <ion-button (click)="close()">ביטול</ion-button>
    </ion-buttons>
    <ion-title>התחברות</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content class="ion-padding">
  <div class="ion-margin-bottom bottom" slot="fixed">
    <form class="login-form" (submit)="formSubmit()">
      <ion-item class="ion-margin-bottom">
        <input [(ngModel)]="form.login.username.value" name="name" type="text"
                   placeholder="{{ form.login.username.label }}"
                   (keyup.enter)="next($event)"
                   enterkeyhint="next" inputmode="text">
      </ion-item>

      <ion-item class="ion-margin-bottom" [ngClass]="displayErrors?'ion-invalid':'ion-valid'" #passwordField>
        <input [(ngModel)]="form.login.password.value" name="password" type="password"
                   (keyup.enter)="formSubmit()"
                   placeholder="{{ form.login.password.label }}" enterkeyhint="send" inputmode="password">
      </ion-item>
      <div *ngIf="errors" class="error">{{ errors }}</div>
      <!--      <div class="err"></div>-->
      <div class="flex ion-margin-bottom">
        <ion-button color="danger" tappable expand="block" type="submit" class="three">
          {{ form.login.submit }}
        </ion-button>
        <ion-button *ngIf="fingerAuth" color="danger" (click)="fingerAuthentication()" tappable expand="block"
                    class="one">
          <ion-icon slot="icon-only" name="finger-print"></ion-icon>
        </ion-button>
      </div>
    </form>
    <div class="additional-buttons">
      <div class="flex">
        <ion-button (click)="goToRegistrationPage()">{{ form.login.join_free }}</ion-button>
        <ion-button color="danger" (click)="goToPasswordRecoveryPage()">{{ form.login.forgot_password }}</ion-button>
      </div>
    </div>
  </div>
</ion-content>

